import { Route } from '@lib/types/route';

export const getRoutes = (): Route[] => [];
